<template>
	<div class="bean">
		<div class="title">
			<div>我的粉丝(62)</div>
		</div>
		<div class="list">
			<div class="list-div"   v-for="(item,index) in list" :key="index">
				<img :src="item.img" />
				<div class="list-center">
					<div>shudoku</div>
					<div>中国|杭州</div>
				</div>
				<div class="list-botton">
					<div>已关注</div>
				</div>
			</div>
			
		</div>
		<el-pagination
		  :page-size="20"
		  :pager-count="11"
		  layout="prev, pager, next"
		  :total="100">
		</el-pagination>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				list:[
					{
						'img': '/img/8.f80b3230.svg'
					},
					{
						'img': '/img/8.f80b3230.svg'
					},
					{
						'img': '/img/8.f80b3230.svg'
					},
					{
						'img': '/img/8.f80b3230.svg'
					},
					{
						'img': '/img/8.f80b3230.svg'
					},
					{
						'img': '/img/8.f80b3230.svg'
					},
					{
						'img': '/img/8.f80b3230.svg'
					},
					
				]
			}
	    },
		methods:{
			url(e){
				this.$router.push(e);
				this.type = e;
				console.log(e)
			}
		},
	}
</script>

<style lang="less">
	.bean {
		width: 100%;
		// background-color: #FFFFFF;
		min-height: 25rem;
		border-radius: 0.2rem;
		color: #7F7F7F;
		.title {
			width: 92%;
			margin: auto;
			border-bottom:1px solid #a29e9eb5;
			line-height: 2rem;
			height: 2rem;
			div {
				padding-left: 0.2rem;
				width:5.2rem;
				border-bottom:2px solid #d63030;
			}
		}
		.list {
			width: 92%;
			margin: auto;
			display: flex;
			flex-wrap: wrap;
			.list-div {
				width: 14.2rem;
				margin: 0.7rem;
				margin-bottom: 0;
				display: flex;
				height: 5rem;
				img {
					padding-top: 1rem;
					width: 2rem;
					height: 2rem;
					padding-left: 0.5rem;
				}
				.list-center {
					padding-top: 0.8rem;
					padding-left: 0.5rem;
					div:nth-last-child(2){
						font-weight: 600;
					}
					div:nth-last-child(1){
						font-size: 0.6rem;
					}
				}
				.list-botton {
					padding-top: 1.2rem;
					padding-left: 1rem;
					div {
						font-size: 0.6rem;
						border-radius: 0.8rem;
						line-height: 1.4rem;
						text-align: center;
						height: 1.4rem;
						width: 3.5rem;
						color: #FFFFFF;
						background-color: rgba(217, 0, 27, 1);
					}
				}
			}
		}
		.el-pagination {
			margin-top: 2rem;
			margin-left: 16rem;
		}
		.el-pagination .btn-next, .el-pagination .btn-prev, .el-pager li {
			background-color: rgb(242, 242, 242) !important;
		}
	}
</style>
